import BaseApi from './base.api'
import ApiService from '@services/api.service'

export default {
    ...BaseApi,
    ...{
        resource: 'nationalities'
    },

    toggleStatus(payload) {
        // expects { id, school_id, is_active }
        return ApiService.post(`/${this.resource}/${payload.id}/toggle-status`, payload);
    }
}
